export const downloadReportPdf = (pdfRef, pdfTitle) => {
    if (pdfRef.current) {
        const element = pdfRef.current
        if (!element) return

        const originalTitle = document.title
        document.title = pdfTitle

        element.classList.add("print-target", "print-fit-charts")
        window.print()
        element.classList.remove("print-target", "print-fit-charts")

        document.title = originalTitle
    }
}
